import './App.css';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AccountsPage from './pages/AccountsPage';
import ArtistDashboardPage from './pages/ArtistDashboardPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import WithdrawRequestPage from './pages/WithdrawRequestPage';
import ManageArtistsPage from './pages/ManageArtistsPage';
import ManageDataPage from './pages/ManageDataPage';
import ManageContentPage from './pages/ManageContentPage';
import AdvanceReportPage from './pages/AdvanceReportPage';
import WithdrawRequestArtistPage from './pages/WithdrawRequestArtistPage';
import LeadsPage from './pages/LeadsPage';
import { AuthProvider } from './context/AuthContext';
import { DataProvider } from './context/DataContext';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import AdminProtectedRoute from './utils/AdminProtectedRoute' 
import UserProtectedRoute from './utils/UserProtectedRoute'
import { AlertProvider } from './context/AlertContext';
import Alert from './components/Alert';



function App() {
  return (
    <Router>
      <AlertProvider>
        <AuthProvider>
          <Alert />
          <Routes>
            <Route path="/" element={<HomePage />} />
            {/* <Route path="/account" element={<AccountsPage />} /> */}
            <Route path="/artist_login" element={<LoginPage />} />
            <Route path="/admin_login" element={<AdminLoginPage />} />
            {/* <Route path="/artist_register" element={<RegisterPage />} */}
            <Route path="/dashboard" element={   
              <UserProtectedRoute>
                <DataProvider>
                    <ArtistDashboardPage />
                  </DataProvider>
              </UserProtectedRoute>
              } />
            <Route path="/withdraw-request-artist" element={
              <UserProtectedRoute>
                <DataProvider>
                    <WithdrawRequestArtistPage />
                  </DataProvider>
              </UserProtectedRoute>
              } />
            <Route path="/admin_dashboard" element={
               <AdminProtectedRoute>
                <DataProvider>
                  <AdminDashboardPage />
                </DataProvider>
               </AdminProtectedRoute>
              } />
              <Route path="/manage-artists" element={
                <AdminProtectedRoute>
                 <DataProvider>
                   <ManageArtistsPage />
                 </DataProvider>
                </AdminProtectedRoute>
               } />
              <Route path="/manage-data" element={
                <AdminProtectedRoute>
                 <DataProvider>
                   <ManageDataPage />
                 </DataProvider>
                </AdminProtectedRoute>
               } />
              <Route path="/manage-content" element={
                <AdminProtectedRoute>
                 <DataProvider>
                   <ManageContentPage />
                 </DataProvider>
                </AdminProtectedRoute>
               } />
              <Route path="/advanced-report" element={
                <AdminProtectedRoute>
                 <DataProvider>
                   <AdvanceReportPage />
                 </DataProvider>
                </AdminProtectedRoute>
              } />
              <Route path="/withdraw_requests" element={
               <AdminProtectedRoute>
                <DataProvider>
                  <WithdrawRequestPage />
                </DataProvider>
               </AdminProtectedRoute>
              } />
              <Route path="/leads" element={
               <AdminProtectedRoute>
                <DataProvider>
                  <LeadsPage />
                </DataProvider>
               </AdminProtectedRoute>
              } />
            {/* <Route path="*" element={<HomePage />} /> */}
          </Routes>
        </AuthProvider>
      </AlertProvider>
    </Router>
  );
}

export default App;
